import styled from "styled-components";
import { mobile } from "../../ui/media";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: ${({ theme }) => theme.zIndex.overlay};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.state.scrim};
`;

export const Dialog = styled.div`
  background: ${({ theme }) => theme.colors.background.liquidGlass};
  backdrop-filter: blur(36px) saturate(180%) brightness(1.05);
  -webkit-backdrop-filter: blur(36px) saturate(180%) brightness(1.05);
  border: 1px solid ${({ theme }) => theme.colors.background.liquidGlassBorder};
  border-radius: ${({ theme }) => theme.radius.xl}px;
  box-shadow: ${({ theme }) => theme.colors.background.liquidGlassHighlight},
    ${({ theme }) => theme.colors.shadow.high};
  padding: ${({ theme }) => theme.spacing(4)};
  max-width: 420px;
  width: calc(100% - ${({ theme }) => theme.spacing(4)});
  outline: none;

  ${mobile} {
    max-width: calc(100% - ${({ theme }) => theme.spacing(4)});
    padding: ${({ theme }) => theme.spacing(3)};
  }
`;

export const Header = styled.header`
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

export const Title = styled.h2`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.h3};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: 700;
`;

export const Body = styled.p`
  margin: 0 0 ${({ theme }) => theme.spacing(2.5)};
  font-size: ${({ theme }) => theme.typography.body};
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: 1.5;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const ErrorMessage = styled.div`
  padding: ${({ theme }) => theme.spacing(1.5)};
  border-radius: ${({ theme }) => theme.radius.md}px;
  background: ${({ theme }) => `${theme.colors.accent.danger}1a`};
  color: ${({ theme }) => theme.colors.accent.danger};
  border: 1px solid ${({ theme }) => theme.colors.accent.danger};
  font-size: ${({ theme }) => theme.typography.small};
  font-weight: 500;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing(1)};
  margin-top: ${({ theme }) => theme.spacing(0.5)};

  ${mobile} {
    flex-direction: column-reverse;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: ${({ theme }) => theme.spacing(1.5)};
  right: ${({ theme }) => theme.spacing(1.5)};
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.text.secondary};
  cursor: pointer;
  padding: ${({ theme }) => theme.spacing(0.5)};
  border-radius: ${({ theme }) => theme.radius.sm}px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  line-height: 1;
  transition: color ${({ theme }) => theme.motion.fast} ease;

  &:hover { color: ${({ theme }) => theme.colors.text.primary}; }
  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 ${({ theme }) => theme.spacing(0.5)}
      ${({ theme }) => theme.colors.border.focus};
  }
`;

export const DialogWrapper = styled.div`
  position: relative;
`;

/* ── The signup route out of the dialog ──
   The prompt invites you to "create an account or log in" but only ever offered the second. */

export const AltAction = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(0.75)};
  margin-top: ${({ theme }) => theme.spacing(2)};
  padding-top: ${({ theme }) => theme.spacing(2)};
  border-top: 1px solid ${({ theme }) => theme.colors.border.subtle};
  font-size: ${({ theme }) => theme.typography.small};
  color: ${({ theme }) => theme.colors.text.secondary};
  text-align: center;
`;

export const AltLink = styled.button`
  min-height: ${({ theme }) => theme.spacing(5.5)};
  padding: 0 ${({ theme }) => theme.spacing(1)};
  border: none;
  background: none;
  color: ${({ theme }) => theme.colors.accent.primary};
  font: inherit;
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }

  &:focus-visible {
    outline: none;
    border-radius: ${({ theme }) => `${theme.radius.xs}px`};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.state.selected};
  }
`;
